export default "__VITE_ASSET__Bh2mX42___"